import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditActionContext } from "./EditActionContext";

function useGet() {
  const { setElement, setShowModal } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    formDefaultValues: any = {},
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get("invoices", id, "?relations=invoice_lines,receiver_account")
      .then((response: any) => {
        let data = response.data;
        const toDateInputFormat = (value: any) => {
          if (!value) return value;
          try {
            const d = new Date(value);
            if (!isNaN(d.getTime())) {
              const yyyy = d.getFullYear();
              const mm = String(d.getMonth() + 1).padStart(2, "0");
              const dd = String(d.getDate()).padStart(2, "0");
              return `${yyyy}-${mm}-${dd}`;
            }
          } catch (_e) {}
          // fallback: recorte ISO
          return typeof value === "string" && value.length >= 10 ? value.slice(0, 10) : value;
        };

        if (data.date) {
          data.date = toDateInputFormat(data.date);
        }
        if (data.expiration_date && typeof data.expiration_date === "string" && data.expiration_date.includes("T")) {
          data.expiration_date = toDateInputFormat(data.expiration_date);
        }
        
        // Permitimos edición aunque tenga PDF generado
        
        data = onSuccess(response.data);
        setElement({ ...formDefaultValues, ...data });
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
